/**
 * WEEX Exchange Metadata
 *
 * Configuration, documentation links, and notes for the WEEX exchange.
 */

import { WEEX_WS_CHANNELS, WEEX_WS_TOPOLOGY } from './ws';

import type { ExchangeId, ExchangeMetadata } from '../../lib/types';

export const WEEX_METADATA: ExchangeMetadata = {
  id: 'weex' as ExchangeId,
  restDocs: ['https://api-spot.weex.com'],
  wsDocs: ['https://api-spot.weex.com'],
  wsTopology: WEEX_WS_TOPOLOGY,
  wsChannels: WEEX_WS_CHANNELS,
  notes: [
    'Uses WEEX v3 spot REST and WebSocket APIs with unsuffixed symbols.',
    'REST helpers normalize bare v3 payloads into internal display DTOs.',
    'WebSocket uses SUBSCRIBE params streams and PONG heartbeats.',
    'Data-only display integration; no order placement.',
  ],
};
